import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import SoloStart from '@/features/Onboarding/SoloStart';
import { useAccountStore } from '@/store/account';

const StartOnboarding = () => {
  const isMarketer = useAccountStore((state) => state.isItMarketer);
  const navigate = useNavigate();

  useEffect(() => {
    if (isMarketer) {
      navigate('/clients');
    }
  }, [isMarketer, navigate]);

  return (
    <div>
      <SoloStart />
    </div>
  );
};

export default StartOnboarding;
